document.addEventListener('DOMContentLoaded', function() {
    // 1. Find the "In Stock" checkbox based on your code structure
    const inStockCheckbox = document.querySelector('input[value="1"][name*="availability"]');
    
    // 2. Check if it exists and isn't already checked
    if (inStockCheckbox && !inStockCheckbox.checked) {
        inStockCheckbox.checked = true;
        
        // 3. Trigger a 'change' event so the Ella theme's AJAX filter recognizes the click
        inStockCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
});


